import React from 'react'
import PropTypes from 'prop-types'
import LinkButton, { LINK_BUTTON_THEMES } from 'components/LinkButton'
import './CountryPageSignUpForNewslettersBlock.scss'

const CountryPageSignUpForNewslettersBlock = ({ intro, buttonUrl, buttonText }) => {
    return (
        <div className='country-page-sign-up-for-newsletters-block'>
            <div className='country-page-sign-up-for-newsletters-block__container'>
                {intro && <div className='country-page-sign-up-for-newsletters-block__intro'>{intro}</div>}
                {buttonUrl && buttonText && (
                    <div className='country-page-sign-up-for-newsletters-block__link-holder'>
                        <LinkButton 
                            url={buttonUrl}
                            text={buttonText}
                            theme={LINK_BUTTON_THEMES.dark}
                        />
                    </div>
                )}
            </div>
        </div>
    ) 
}

CountryPageSignUpForNewslettersBlock.propTypes = {
    intro: PropTypes.string,
    buttonText: PropTypes.string,
    buttonUrl: PropTypes.string
}

export default CountryPageSignUpForNewslettersBlock
